import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalMessageEntities, GlobalMessageType } from '@spartacus/core';
import { ICON_TYPE } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { KbMyTicketService } from 'src/app/services/feature/mytickets/kb-my-tickets.service';

@Component({
  selector: 'app-kbcreatenew-ticket',
  templateUrl: './kbcreatenew-ticket.component.html',
  styleUrls: ['./kbcreatenew-ticket.component.scss'],
  standalone: false
})
export class KbcreatenewTicketComponent {
  isMobile: boolean = false;
  sub = new Subscription();

  iconTypes = ICON_TYPE;
  messages$: Observable<GlobalMessageEntities>;
  messageType: typeof GlobalMessageType = GlobalMessageType;
  messages: any[] = [];
  myTicket = this.service.customerId;

  getData: any;
  associatedTo: any;
  userSelectedFile: File;
  fileName: string = undefined;
  filenameisThere: boolean = true;

  messageKey = 'common.supportticket_message_invalid';
  categoryKey = 'common.supportticket_category_invalid';
  subjectKey = 'common.supportticket_subject_invalid';
  associatedToKey = 'common.supportticket_associatedTo_invalid';
  commonErrorsKey = 'common.form_global_error';


  constructor(private breakpointObserver: BreakpointObserver,
    private service: KbMyTicketService,
    private scroller: ViewportScroller,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }

  createnewTicket = new FormGroup({
    customerId: new FormControl(null, [Validators.required]),
    subject: new FormControl(null, [Validators.required]),
    categoryId: new FormControl(null, [Validators.required]),
    associatedTo: new FormControl(null, [Validators.required]),
    message: new FormControl(null, [Validators.required]),
  })
  get form() {
    return this.createnewTicket.controls;
  }

  ngOnInit() {
    this.sub.add(this.service.createNewGetApi().subscribe((data: any) => {
      if (data) {
        this.getData = data;
        const selectedSoldTo = data?.b2bUnitsWSList.find((soldTo) => { if (soldTo.uid == data?.defaultSoldTo) { return soldTo; } });
        this.form.customerId.patchValue(selectedSoldTo.uid);
        this.cdr.detectChanges();
      }
    }));
  }
  onSetCusID() {
    this.sub.add(this.service.createNewGetApi().subscribe((data: any) => {
      this.getData = data;
      const selectedSoldTo = data?.b2bUnitsWSList.find((soldTo) => { if (soldTo.uid == data?.defaultSoldTo) { return soldTo; } });
      this.form.customerId.patchValue(selectedSoldTo.uid);
    }));
  }
  onSubmit() {
    this.messages.splice(0, this.messages.length);
    if (this.createnewTicket.valid) {
      const file = new FormData();
      if (this.userSelectedFile) {
        file.append('document', this.userSelectedFile);
      }
      this.sub.add(this.service.createNewTicketPostApi(this.createnewTicket.value, file).subscribe((x: any) => {
        this.service.isFromCreatenewTicketPage = true;
        this.service.isFromCreatenewTicketPageKey = x[0]?.success;
        this.router.navigateByUrl('support-tickets');
      }))
    } else {
      //need to show errors to user
      this.messages.push(this.commonErrorsKey);
      if (this.form.associatedTo.invalid) {
        this.messages.push(this.associatedToKey);
      }
      if (this.form.subject.invalid) {
        this.messages.push(this.subjectKey);
      }
      if (this.form.categoryId.invalid) {
        this.messages.push(this.categoryKey);
      }
      if (this.form.message.invalid) {
        this.messages.push(this.messageKey);
      }
      this.messages.reverse();
      this.scroller.scrollToPosition([0, 200]);
    }
  }
  resetButton() {
    this.createnewTicket.reset();
    this.onSetCusID();
  }

  checkCustomeridisFilled(apiData: string) {
    if (this.form.customerId.invalid) {
      this.form.customerId.setValue(apiData);
    }
  }

  onCategoryChange() {
    this.sub.add(this.service.onCustomerIdSelect(this.form.customerId.value, this.form.categoryId.value).subscribe((res: any) => {
      this.associatedTo = res?.associatedObjects;
    }))
  }
  clear(i: number): void {
    this.messages.splice(i, 1);
  }
  onFileSelected(event: any): void {
    const selectedFile = event.files[0];
    this.userSelectedFile = selectedFile;
    this.fileName = selectedFile.name;
    this.filenameisThere = false;
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.sub.unsubscribe();
  }

}
